import React from 'react';

import { Avatar } from '@change/ds-core-ui/Avatar';
import { Text } from '@change/ds-core-ui/Text';

import { useTracking } from '../../../hooks/useTracking';
import { DecisionMakerResponse } from '../../../shared/components/DecisionMakerResponse';
import { Name } from '../../../shared/components/Name';
import { Signers } from '../../../shared/components/Signers';
import { SignersTooltip } from '../../../shared/components/SignersTooltip';
import type { NormalizedDecisionMaker } from '../../../shared/types';

export const Member: React.FC<NormalizedDecisionMaker> = ({
	photoUrl,
	displayName,
	publiclyVisible,
	slug,
	id,
	title,
	constituentCount,
	constituentCountLocalized,
	isFormer,
	response,
}) => {
	const { trackDMMoreInfoClick } = useTracking();
	return (
		<div className="flex" data-qa="dm-card">
			<Avatar src={photoUrl || undefined} alt={displayName} size={32} className="mr-3 mb-3 shrink-0" />
			<div className="flex flex-col md:items-start">
				<div className="mb-2">
					<div className="flex items-center gap-1.5">
						<Name displayName={displayName} id={id} publiclyVisible={publiclyVisible} slug={slug} />
						{constituentCount > 0 && (
							<div className="lg:hidden">
								<SignersTooltip
									constituentCount={constituentCount}
									constituentCountLocalized={constituentCountLocalized}
									isFormer={isFormer}
									onTooltipClick={() => trackDMMoreInfoClick(id)}
								/>
							</div>
						)}
					</div>

					<div className="flex flex-wrap items-center gap-x-3 gap-y-2">
						<Text variant="body" className="text-muted text-sm">
							{title}
						</Text>

						{constituentCount > 0 && (
							<div className="hidden lg:inline-block">
								<Signers
									constituentCount={constituentCount}
									constituentCountLocalized={constituentCountLocalized}
									isFormer={isFormer}
								/>
							</div>
						)}
					</div>
				</div>

				{response && <DecisionMakerResponse response={response} />}
			</div>
		</div>
	);
};
